import React from 'react';
const Page404: React.FC = () => {

    return (<h1>Attention cette page n'existe pas !</h1>);

}
export default Page404;
